module.exports = __webpack_public_path__ + "img/Shoulder_NORE.c33b7dd4.jpg";